<section class="our-values">
    <div class="header">
        <div>
            <app-badge text="Esencia que perdura"></app-badge>
            <h2 class="title">Conoce nuestros valores</h2>
        </div>
        <!-- <p class="description">En Paredes Asociados, nuestros valores fundamentales son el corazón de todo lo que hacemos. Nos guían en cada proyecto, en cada interacción y en cada decisión que tomamos. Estos valores no solo definen quiénes somos como empresa, sino que también reflejan nuestro compromiso con la excelencia, la integridad y la innovación en el mundo de la construcción.</p> -->
    </div>
    <div class="content">
        <div class="image-container">
            <img src="assets/images/home/values-increase.webp" alt="Nuestros Valores" class="image">
        </div>
        <div class="values-list-container">

            <div>
                <app-badge text="Desde hace 30 años"></app-badge>
                <h3 class="description">Lo que guía cada proyecto </h3>
            </div>

            <div 
                [ngClass]="{ 'marked': i === 0}" 
                class="value" *ngFor="let value of values; index as i; trackBy: trackElement">
                <!-- <div class="icon">
                <lucide-icon [name]="value.icon" [size]="75"></lucide-icon>
            </div> -->
                <span 
                    class="number"
                    [ngClass]="{ 'number-marked': i === 0}"
                >{{ i + 1 }}</span>
                <div>
                    <h4 class="value-title">{{ value.title }}</h4>
                    <p class="value-description">{{ value.description }}</p>
                </div>
            </div>
        </div>
    </div>

</section>